import CompanyRegistrationsService from "@apps/Shared/Services/CompanyRegistrations/CompanyRegistrations.service";
import { StatusCode } from "@apps/Shared/Services/Response.types";

export function fetchMunicipalities(
    setMunicipalities: Function,
    setUnexpectedErrors: Function
) {
    CompanyRegistrationsService.GetMunicipalities()
        .then(result => {
            if (result.response?.status === StatusCode.OK) {
                setMunicipalities(result.response.data)
            } else {
                const errorMessages = result.errors

                setUnexpectedErrors(errorMessages || [])
            }
        })
        .catch((error: any) => {
            console.log(error)
        })
}

export function fetchAssociationHeards(
    setHeards: Function,
    setUnexpectedErrors: Function
) {
    CompanyRegistrationsService.GetAssociationHeards()
        .then(result => {
            if (result.response?.status === StatusCode.OK) {
                setHeards(result.response.data)
            } else {
                const errorMessages = result.errors

                setUnexpectedErrors(errorMessages || [])
            }
        })
        .catch((error: any) => {
            console.log(error)
        })
}

export function fetchCampsiteHeards(
    setHeards: Function,
    setUnexpectedErrors: Function
) {
    CompanyRegistrationsService.GetCampsiteHeards()
        .then(result => {
            if (result.response?.status === StatusCode.OK) {
                setHeards(result.response.data)
            } else {
                const errorMessages = result.errors

                setUnexpectedErrors(errorMessages || [])
            }
        })
        .catch((error: any) => {
            console.log(error)
        })
}

export function fetchSkiResortHeards(
    setHeards: Function,
    setUnexpectedErrors: Function
) {
    CompanyRegistrationsService.GetSkiResortHeards()
        .then(result => {
            if (result.response?.status === StatusCode.OK) {
                setHeards(result.response.data)
            } else {
                const errorMessages = result.errors

                setUnexpectedErrors(errorMessages || [])
            }
        })
        .catch((error: any) => {
            console.log(error)
        })
}

export function fetchWorkPlaceHeards(
    setHeards: Function,
    setUnexpectedErrors: Function
) {
    CompanyRegistrationsService.GetWorkPlaceHeards()
        .then(result => {
            if (result.response?.status === StatusCode.OK) {
                setHeards(result.response.data)
            } else {
                const errorMessages = result.errors

                setUnexpectedErrors(errorMessages || [])
            }
        })
        .catch((error: any) => {
            console.log(error)
        })
}